import React, { useRef, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import NewsListItem from './NewsListItem/';
import { Button } from 'reactstrap';
import OwlCarousel from '../../components/OwlCarousel/OwlCarousel';
import { chunk } from '../../utils/utils';

const ITEMS_PER_PAGE = 4;

const owlConfig = {
  className: 'owl-theme owl-footer-dots',
  items: 1,
  loop: false,
  nav: false,
  margin: 0,
  lazyLoad: true,
};

const NewsList = ({ news = [], groupByDate = false, inOffer, addMore, handleAddMore }) => {
  const contentRef = useRef(null);
  const [isWideLayout, setIsWideLayout] = useState(false);
  const [paginatedNews, setPaginatedNews] = useState(null);

  useEffect(() => {
    if (news?.length > 0) {
      const paginated = chunk(news, ITEMS_PER_PAGE);
      setPaginatedNews(paginated);
    } else {
      setPaginatedNews(null);
    }
  }, [news]);

  useEffect(() => {
    const checkWidth = () => {
      if (contentRef.current) {
        const contentWidth = contentRef.current.offsetWidth;
        setIsWideLayout(contentWidth > 550);
      }
    };

    const mutationObserver = new MutationObserver(() => {
      checkWidth();
    });

    if (contentRef.current) {
      mutationObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style'],
      });
    }

    checkWidth();

    return () => {
      mutationObserver.disconnect();
    };
  }, []);

  const renderNewsPages = (newsPage) => {
    if (!newsPage) return null;

    return newsPage.map((newsItem) => (
      <NewsListItem key={newsItem.id} groupByDate={groupByDate} news={newsItem} inOffer={inOffer} />
    ));
  };

  const renderNewsList = () => {
    return news.map((newsItem) => (
      <NewsListItem key={newsItem.id} groupByDate={groupByDate} news={newsItem} inOffer={inOffer} />
    ));
  };

  const shouldShowCarousel = isWideLayout && paginatedNews && paginatedNews.length > 0;
  const shouldShowList = !isWideLayout && news.length > 0;

  return (
    <div ref={contentRef} className="news-content">
      {shouldShowCarousel && (
        <OwlCarousel {...owlConfig}>
          {paginatedNews.map((page, index) => (
            <div key={index} className="news-content-page">
              {renderNewsPages(page)}
            </div>
          ))}
        </OwlCarousel>
      )}

      {shouldShowList && <div className="news-content-list">{renderNewsList()}</div>}

      {news.length === 0 && (
        <div className="card-empty">
          <FormattedMessage id="news.no-news" defaultMessage="No News" />
        </div>
      )}

      {addMore && (
        <Button color="primary" size="sm" onClick={handleAddMore}>
          <FormattedMessage id="widgets.news.button" defaultMessage="Load more" />
        </Button>
      )}
    </div>
  );
};

export default NewsList;
